export const MEETINGS_LIMIT = 15;
export const STORAGE_NAME_IS_SHOW_CANSELED_MEETIONGS = 'isShowCanseledMeetings';
